import { createFileRoute, notFound } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import gymsStyles from "../styles/platform-gyms.css?url";
import { planCopy, regularMonth } from "../../src/lib/plan-copy";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { GymsPage } from "../platform/gyms-page";
import { loadGymsPage } from "../platform/product-pages";

/**
 * Drate's page for gyms and fitness coaches (/for-gyms), where the fitness coaches' video ad
 * lands; a 404 on creator sites. The phones' headlines are set in Barlow Condensed, which loads
 * with the page so they never swap faces as they rise.
 */
export const Route = createFileRoute("/for-gyms")({
  loader: async () => {
    const page = await loadGymsPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    if (!loaderData) return {};
    const shell = platformShellFrom(matches);
    const pick = planCopy(shell?.regular ?? false);
    const head = withStylesheet(
      withStylesheet(
        platformPageHead(shell, {
          pathname: "/for-gyms",
          title: pick(
            "Your gym’s own app and website, free to start | Drate",
            "Your gym’s own app and website | Drate",
          ),
          description: pick(
            "Sell memberships on your own site and give members an app with your gym’s name on it. Free to start.",
            `Sell memberships on your own site and give members an app with your gym’s name on it. Plans from ${regularMonth} a month.`,
          ),
          canonicalPath: "/for-gyms",
          structuredData: JSON.parse(loaderData.structuredData) as StructuredData,
        }),
        homeStyles,
      ),
      gymsStyles,
    );
    return {
      ...head,
      links: [
        ...(head.links ?? []),
        {
          rel: "preload",
          href: "/_app/fonts/barlow-condensed-700-latin.woff2",
          as: "font",
          type: "font/woff2",
          crossOrigin: "anonymous" as const,
        },
      ],
    };
  },
  component: GymsPage,
});
